import React, { useEffect } from 'react';
import styles from './index.module.css';
import Card from '../../../components/Card/index';
import BarChart from '../../../components/BarChart/index';
import iconOne from '../../../assets/images/icons/payments 2@3x.png';
import iconSecond from '../../../assets/images/icons/payments@3x.png';
import iconThird from '../../../assets/images/icons/students@3x.png';
import ScatterChart from '../../../components/ScatterChart/index';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomers, getTicketCount, getWinners } from '../../../redux/features/dashboard/dashboardService';
import Skeleton from 'react-loading-skeleton';

const ViewerDashboard = () => {
  
  const dispatch = useDispatch();
  const { isCountLoading, count, unsold_count } = useSelector((state) => state.dashboard.ticketCount);
  const { isWinnersLoading, winners } = useSelector((state) => state.dashboard.winnersCount);
  const { isCustomersLoading, customers } = useSelector((state) => state.dashboard.customerCount);

  useEffect(() =>{
    dispatch(getTicketCount());
    dispatch(getCustomers());
    dispatch(getWinners());
  }, [dispatch]);

  return (
    <div>
      <div className={styles.cardContainer}>
        <div className={styles.topCardContainer}>
          <Card icon={iconOne} text='Sold Tickets' number={isCountLoading? <Skeleton/> : count} />
        </div>
        <div className={styles.middleCardContainer}>
          <Card icon={iconSecond} text='Remaining Tickets'  number={isCountLoading? <Skeleton/> : unsold_count} />
        </div>
        <div className={styles.bottomCardContainer}>
          <Card icon={iconThird} text='Customers' number={isCustomersLoading? <Skeleton/> : customers} />
        </div>
        <div className={styles.fourthCardContainer}>
          <Card icon={iconOne} text='Winners' number={isWinnersLoading? <Skeleton/> : winners} />
        </div>
      </div>
      <div className={styles.graphContainer}>
        <div className={styles.lineChartContainer}>
          <ScatterChart chartTitle='Lottery Count'/>
        </div>
        <div className={styles.barChartContainer}>
          <BarChart
            chartTitle='Sales'
          />
        </div>
      </div>
    </div>
  );
};

export default ViewerDashboard;
